import SearchField from '@components/v2/ui/FilterBar/components/SearchField/SearchField';
import useTextFilter from '../../../components/Crud/filters/hooks/textFilter/useTextFilter';
import useWidth from '../../../components/Hooks/useWidth';
import LangEnum from '../../../lang/LangEnum';
import { CatalogTestIds } from '../../../utils/testIds/catalog.testIds';
import { CATALOG_LIST_FILTERS_KEYS } from './catalogListFilter.utils';

interface UseCatalogListSearchFieldParams {
  defaultValue?: string;
  shouldIgnoreDefaultFilters?: boolean;
}

const useCatalogListSearchField = ({
  defaultValue,
  shouldIgnoreDefaultFilters,
}: UseCatalogListSearchFieldParams = {}) => {
  const { mobileWidth } = useWidth();

  const searchTextFieldHook = useTextFilter({
    key: CATALOG_LIST_FILTERS_KEYS.query,
    isAutoApply: mobileWidth,
    defaultValue,
    shouldIgnoreDefaultFilters,
  });

  const searchField = (
    <SearchField
      value={searchTextFieldHook.value}
      placeholder={LangEnum.CATALOGS_LIST_FILTER_SEARCH_PLACEHOLDER}
      testId={CatalogTestIds.CATALOG_SEARCH_FIELD}
      inputRef={searchTextFieldHook.textFieldRef}
      onChange={searchTextFieldHook.setValue}
      onClear={searchTextFieldHook.cleanFilter}
    />
  );

  return {
    searchField,
    isSearchActive: Boolean(searchTextFieldHook.value),
    onClearSearch: searchTextFieldHook.cleanFilter,
  };
};

export default useCatalogListSearchField;
